import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const OurTeam = () => {
    const { t } = useTranslation();
    const siteLink = "<a href='https://sites.northwestern.edu/milkievugroup' target='_blank' rel='noopener' style='color: rgb(91, 59, 140)'>sites.northwestern.edu/milkievugroup</a>";
    const visitLab = t('our_team.visit_lab').replace('https://sites.northwestern.edu/milkievugroup/', siteLink);;

    return (
        <Fade in timeout={1000}>
            <div className='main'>
                <Typography variant='h4'>{t('our_team.title')}</Typography>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row'}, mt: { xs: 2, md: 4 }, justifyContent: 'center', alignItems: 'flex-start' }}>
                    <Box component="img" src='/images/team_img.webp' alt={t('our_team.title')} sx={{ width: { xs: '100%', md: '50%'}, height: 'auto', objectFit: 'contain', mb: 2, border: '5px solid black' }} />
                    <Paper elevation='2' sx={{ width: { xs: '100%', md: '50%'}, mx: { md: '1rem' }, padding: '1rem', backgroundColor: '#f7f7f7' }}>
                        <Typography variant='h6' sx={{ fontWeight: 600 }}>{t('our_team.milkie_vu_name')}</Typography>
                        <Typography variant='body1' sx={{ mt: 2 }}>{t('our_team.milkie_vu_description')}</Typography>
                        <Typography variant='body1' sx={{ mt: 2 }} dangerouslySetInnerHTML={{__html: visitLab}}></Typography>
                    </Paper>
                </Box>
            </div>      
        </Fade>
    )
}

export default OurTeam;